var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIllustrationWaterHeaterActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4364_28277)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7715,
    cy: 40.7735,
    rx: 14.7403,
    ry: 14.7403,
    fill: "url(#paint0_linear_4364_28277)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7127 49.0456L47.7239 49.038L47.7345 49.0296C47.8984 48.899 48.061 48.6769 48.061 48.3878V31.6871C48.061 31.2552 47.7097 30.9039 47.2778 30.9039H47.2776H34.7145C34.2825 30.9039 33.9313 31.2552 33.9313 31.6871V48.3878C33.9313 48.6505 34.0501 48.8927 34.2817 49.0471L34.4759 48.7559L34.2795 49.0456C36.2887 50.4077 38.6539 51.0985 40.9961 51.0985C43.3384 51.0985 45.7036 50.4068 47.7127 49.0456ZM46.4944 32.4703V47.9793C43.1535 50.065 38.8385 50.065 35.4977 47.9793V32.4703H46.4944Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9949 45.2403C40.2288 45.2403 39.6026 45.8665 39.6026 46.6326C39.6026 47.3988 40.2288 48.0249 40.9949 48.0249C41.7611 48.0249 42.3872 47.3988 42.3872 46.6326C42.3872 45.8444 41.7601 45.2403 40.9949 45.2403ZM40.9949 46.9732C40.8075 46.9732 40.6544 46.8201 40.6544 46.6326C40.6544 46.4452 40.8075 46.2921 40.9949 46.2921C41.1824 46.2921 41.3355 46.4452 41.3355 46.6326C41.3355 46.8201 41.1824 46.9732 40.9949 46.9732Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.185339
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.228 40.5049L43.2282 40.505L43.2339 40.4942C43.6394 39.7347 43.6135 38.8654 43.1574 38.1303L43.1574 38.1303L43.1554 38.127L41.6823 35.8096L41.6823 35.8096L41.6787 35.8041C41.5236 35.5699 41.2803 35.4527 41.0188 35.4527C40.7562 35.4527 40.5139 35.5716 40.3596 35.8032L40.3595 35.8032L40.3554 35.8096L38.8823 38.127L38.8823 38.127L38.8804 38.1301C38.4294 38.8559 38.3721 39.7274 38.8047 40.496C39.217 41.2886 40.077 41.7844 40.9977 41.7844H40.9977C41.9242 41.7844 42.7764 41.2844 43.228 40.5049ZM40.1323 39.7225C40.0085 39.5021 40.0108 39.2268 40.1701 38.9528L40.9977 37.6632L41.828 38.957C41.9796 39.201 41.9926 39.4784 41.8579 39.732L41.8574 39.733C41.7104 40.0121 41.408 40.196 40.9977 40.196C40.5976 40.196 40.3046 40.0193 40.1323 39.7225Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4364_28277",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.114844 0 0 0 0 0.222396 0 0 0 0 0.4375 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4364_28277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4364_28277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4364_28277",
    x1: 47.8876,
    y1: 33.6227,
    x2: 20.4277,
    y2: 68.6233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustrationWaterHeaterActive);
export default __webpack_public_path__ + "static/media/home_illustration_water_heater_active.f5c9f0c4487860dc2fb112b4006e8485.svg";
export { ForwardRef as ReactComponent };